import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Venue from './pages/Venue';
import Parking from './pages/Parking';
import Garden from './pages/Garden';
import Hall from './pages/Hall';
import House from './pages/House';
import BridalRoom from './pages/BridalRoom';
import FamilyRoom from './pages/FamilyRoom';
import Catering from './pages/Catering';
import Flower from './pages/Flower';
import YourWedding from './pages/YourWedding';
import Reservation from './pages/Reservation';
import Moments from './pages/Moments';
import FAQ from './pages/FAQ';
import QuoteCalculator from './pages/QuoteCalculator';
import './App.css';
import ChatBot from './components/ChatBot';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/venue" element={<Venue />} />
            <Route path="/venue/parking" element={<Parking />} />
            <Route path="/venue/garden" element={<Garden />} />
            <Route path="/venue/hall" element={<Hall />} />
            <Route path="/venue/house" element={<House />} />
            <Route path="/venue/bridal-suite" element={<BridalRoom />} />
            <Route path="/venue/family-lounge" element={<FamilyRoom />} />
            <Route path="/catering" element={<Catering />} />
            <Route path="/flower" element={<Flower />} />
            <Route path="/your-wedding" element={<QuoteCalculator />} />
            <Route path="/reservation" element={<Reservation />} />
            <Route path="/moments" element={<Moments />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/wedding-guide" element={<QuoteCalculator />} />
          </Routes>
        </main>
        <Footer />
        <ChatBot />
      </div>
    </Router>
  );
}

export default App;
